export default __webpack_public_path__ + "static/media/banner_va_1.d0f6c839.jpg";